import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  ActiveSessionControlAction,
  IndicatorDisplayMode,
} from '@/models/analytics/features/sessions';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

interface UseIndicatorAnalyticsProps {
  readonly sessionId: string;
  readonly isSidebarOpen: boolean;
}

export function useIndicatorAnalytics({
  sessionId,
  isSidebarOpen,
}: UseIndicatorAnalyticsProps) {
  const router = useRouter();

  const displayMode = isSidebarOpen
    ? IndicatorDisplayMode.Expanded
    : IndicatorDisplayMode.Collapsed;

  const trackIndicatorClicked = useCallback(() => {
    track({
      event_name: TrackingEventName.ActiveSessionIndicatorClicked,
      props: {
        session_id: sessionId,
        display_mode: displayMode,
        current_page: router.pathname,
      },
    });
  }, [sessionId, displayMode, router.pathname]);

  const trackControlClicked = useCallback(
    (action: 'pause' | 'resume' | 'stop') => {
      const actionEnum: ActiveSessionControlAction =
        action === 'pause'
          ? ActiveSessionControlAction.Pause
          : action === 'resume'
            ? ActiveSessionControlAction.Resume
            : ActiveSessionControlAction.Stop;
      track({
        event_name: TrackingEventName.ActiveSessionControlClicked,
        props: {
          session_id: sessionId,
          action: actionEnum,
          display_mode: displayMode,
          current_page: router.pathname,
        },
      });
    },
    [sessionId, displayMode, router.pathname]
  );

  return {
    trackIndicatorClicked,
    trackControlClicked,
  };
}
